import { LayoutService } from '@app/layout/layout.service';
import { RecordLine, RecordModel } from '../layout/record-model';
import * as Handlebars from 'handlebars';

export class ModuleStructure {
  module: Module;
  defaultValues: Values;
  buttons: ModuleButton[];

  static refineTheRecordModel(
    layoutService: LayoutService,
    moduleStructure: ModuleStructure,
    recordModel: RecordModel,
    defaultVals: any,
    fromDefault: boolean = false,
  ) {
    recordModel.ModuleApp =
      moduleStructure.module.AdditionalInformationParsed.ModuleApp;
    recordModel.AllowSaveToDraft =
      moduleStructure.module.AdditionalInformationParsed.AllowSaveToDraft;

    const docType = recordModel.Categories.find(
      (x) => x.Id === 'Documents',
    )?.Lines[0]?.Properties?.find((z) => z.Name === 'DocType')?.ValueAsObject;
    for (const section of moduleStructure.module.Sections) {
      let recordCategory = recordModel.Categories.find(
        (category) => category.Id === section.XmlTagName,
      );
      if (docType != null && docType !== undefined && docType !== '') {
        if (
          (docType === 'S' || docType === 'dDocument_Service') &&
          section.AdditionalIdentifier === 'items'
        ) {
          continue;
        }
        if (
          (docType === 'I' || docType === 'dDocument_Items') &&
          section.AdditionalIdentifier === 'services'
        ) {
          continue;
        }
      }
      if (recordCategory === undefined || recordCategory === null) {
        recordCategory = {
          Id: section.XmlTagName,
          Lines: [],
        };

        if (section.Type === 1) {
          recordCategory.Lines.push({
            Id: 0,
            Properties: [],
          });
        }

        recordModel.Categories.push(recordCategory);
      }
      for (const recordLine of recordCategory.Lines) {
        recordLine.QuantityProp = recordLine.Properties.find(
          (p) =>
            p.Name === 'Quantity' ||
            p.Name === 'UoMCountedQuantity' ||
            p.Name == 'PickedQuantity',
        );
        recordLine.OpenQtyProp = recordLine.Properties.find(
          (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity',
        );
        recordLine.BaseItemCodeProp = recordLine.Properties.find(
          //(p) => p.Name === 'ITM_BOM_BASE_BaseItem'
          (p) => p.Name === 'U_ITM_BWEB_PARENT_ITEM',
        );
        recordLine.TreeTypeProp = recordLine.Properties.find(
          (x) => x.Name === 'TreeType',
        );
        recordLine.ItemCodeProp = recordLine.Properties.find(
          (x) => x.Name === 'ItemCode',
        );

        if (fromDefault) {
          // we should add configuration for this
          layoutService.triggerFieldValueChangedCustom({
            recordModel: recordModel,
            recordProperty: recordLine.ItemCodeProp,
            formId: '',
            line: recordLine.Id,
            sectionTagName: 'Document_Lines',
            moduleStructure: moduleStructure,
            internalTrigger: true,
          });
        }

        if (
          section.AdditionalInformationParsed.LineTemplate !== '' &&
          section.AdditionalInformationParsed.LineTemplate != null &&
          section.AdditionalInformationParsed.LineTemplate !== undefined
        ) {
          const template = Handlebars.compile(
            section.AdditionalInformationParsed.LineTemplate,
          );
          const html = template(recordLine);
          recordLine.LineTemplateHtml = html;
          recordLine.QuantityProp = recordLine.Properties.find(
            (p) =>
              p.Name === 'Quantity' ||
              p.Name === 'UoMCountedQuantity' ||
              p.Name == 'PickedQuantity',
          );
          recordLine.OpenQtyProp = recordLine.Properties.find(
            (p) => p.Name === 'OpenQty' || p.Name == 'ReleasedQuantity',
          );
        }

        RecordModel.refineTheRecordModelLine(
          layoutService,
          section,
          recordLine,
          defaultVals,
        );

        if (recordLine.QuantityProp === undefined) {
          recordLine.QuantityProp = recordLine.Properties.find(
            (p) =>
              p.Name === 'Quantity' ||
              p.Name === 'UoMCountedQuantity' ||
              p.Name == 'PickedQuantity',
          );
        }

        /*layoutService.lineAdded.emit({
          recordLine,
          moduleStructure: moduleStructure,
          section: section,
          recordModel: recordModel,
        });*/
      }
    }
  }
}

export class Module {
  GoBackAfterAdd: boolean;
  CreationInsideDoc: boolean;
  FirstEmailSign: number;
  LaterEmailSign: number;
  ObjectType: string;
  ObjectTypeValue: string;
  TableName: string;
  Name: string;
  PluralName: string;
  PrimaryKey: string;
  PrimaryKeyProperty: string;
  Type: string;
  SupportedActions: string;
  OrderByScript: string;
  MandatoryFilter?: string;
  JscriptOnLoad?: string;
  RemoveMethodName: string;
  UpdateMethodName: string;
  CreateMethodName: string;
  ModuleType: number;
  MandatoryFilterMode: number;
  ScanQuery?: any;
  AdditionalInformation: string;
  ScanningEnabled: boolean;
  BaseModuleId?: number;
  LayoutDefinitionId: number;
  EmailSubjectTemplate?: string;
  EmailBodyTemplate?: string;
  AdditionalInformationParsed: ModuleAdditionalInformation;
  CustomerPortalFieldFilter: string;
  SQLStatementDataID?: number;
  SearchExps: any[];
  Sections: Section[];
  FieldDescription: string;
  Id: number;
  //RecordDescription: string;
  //Areas: number[];
}

export enum ModuleInventoryDirection {
  Inbound,
  Outbound,
  None,
  Counting,
}

export interface ModuleAdditionalInformation {
  AfterCreateGoToNew: boolean;
  RecordDetailsFieldName: any;
  MobileListTemplate?: string;
  ListTemplate: string;
  SingleSelection: boolean;
  HideViewButton: boolean;
  HideDuplicateButton: boolean;
  ForbidEditQuery?: string;
  ReloadAfterUpdate: string;
  ListTableName?: string;
  SingleSelectionWithCheckBox: boolean;
  AdditionalSearchFields: any[];
  AutoCompleteTemplate?: any;
  ShortName: string;
  SearchOnlyOnPrimayKey: boolean;
  EnableKanban: boolean;
  KanbanBoardsQueryId: number;
  KanbanPropertyName: string;
  InventoryDirection: ModuleInventoryDirection;
  WhenScanLookForExistingBatch: boolean;
  ShowCommentSection: boolean;
  ShowCommunication: boolean;
  ShowAddButton: boolean;
  ShowBackButton: boolean;
  ShowDuplicateButton: boolean;
  TokenizedPageEditable: boolean;
  TokenizedPageHeaderTemplate: string;
  TokenizedPageLineHeaderTemplate: string;
  TokenizedLineTemplate: string;
  TokenizedFooterTemplate: string;
  IsCustomData: boolean;
  CustomDataSource: string;
  ModuleApp: string;
  AllowSaveToDraft: boolean;
  GoBackAfterCreate: boolean;
  AllowCopyFrom: boolean;
  ActionsExpanded: boolean;
  NavigateToRecordDirectly: boolean;
  ExecuteViewRecordAfterAdd: boolean;
  AdditionalLayouts: number[];
  AllowExportToExcel: boolean;
  AllowSaveToFinalDocument: boolean;
  SubmitButtonIcon: string;
  AddButtonText: string;
  UpdateButtonText: string;
  ViewButtonText: string;
  ListHintMessage: string;
  DisplaySuccessMessageAfterAdd: boolean;
  SuccessMessageAfterAdd: string;
  DisplayViewRecordBtnAfterAdd: boolean;
  DisplayAddNewBtnAfterAdd: boolean;
  DisplayGoToListBtnAfterAdd: boolean;
  CustomConditionSectionId: number;
  ClearCustomConditionButtonLabel: string;
  CustomConditionInfoKeysLabel: string;
  DisplayConfirmationMessage: boolean;
  ConfirmationMessageText: string;
}

export interface SectionGroup {
  Key: string;
  Value: Section[];
}

export interface Section {
  DrawerOpen: boolean;
  ModuleName: string;
  TitleForList: string;
  ModuleId: number;
  SQLStatementId?: number;
  XmlTagName: string;
  Title: string;
  Type: SectionType;
  SortOrder: number;
  ParentSection?: any;
  InheritType: number;
  RelationTagName?: any;
  ParentFieldName?: any;
  AdditionalIdentifier: string;
  Icon?: any;
  TabGroup: string;
  ColumnSettings?: any;
  ParentFields?: any;
  AdditionalInformation: string;
  KeyPropertyName: string;
  KeyFieldName: string;
  PropertyNameInParent: string;
  AlwaysHasDefaultValue: boolean;
  Disabled: boolean;
  AdditionalInformationParsed: SectionAdditionalInformation;
  Fields: Field[];
  ColumnSettingsParsed: any[];
  FieldDescription: string;
  PortalStatus: number;
  Id: number;
  //RecordDescription: string;
  //Areas: number[];
}
export enum SectionType {
  Normal = 1,
  Lines = 2,
  Table = 3,
  Chart = 4,
  Cards = 5,
  Calendar = 6,
  Columns = 7,
  Filter = 8,
  List = 9,
  Media = 10,
}

export interface SectionAdditionalInformation {
  IsInDrawer: boolean;
  EnableFilter: boolean;
  EnablePaging: boolean;
  DefaultPageSize: number;
  Hidden: boolean;
  IsCounterSpecial: boolean;
  FlexibleWidth: boolean;
  DefaultColumnWidth: number;
  AdditionalCSS: string;
  CounterAfter: number;
  CounterTitle: string;
  TabGroupIcon: string;
  TabGroupTitle: string;
  TabGroupButtonColor: string;
  TabGroupButtonInHeader: boolean;
  EnablePlusButtonForResponsive: boolean;
  TrimTextCellIfGreaterThanLimit: boolean;
  CellTextLimit: number;
  VisibleColumnsInMobile: number;
  VisibleColumnsInPad: number;
  AllowDelete: boolean;
  AllowDeleteForNewLines: boolean;
  AllowAdd: boolean;
  AllowAddInEditMode: boolean;
  AllowDuplicate: boolean;
  IsGhost: boolean;
  FixedHeader: boolean;
  TableFixedHeight: number;
  SaveCountIn: string;
  ExecuteQueryEvenWhenAdd: boolean;
  ShowSectionInAddMode: boolean;
  LabelVertical: boolean;
  CounterVisible: boolean;
  ActionAtTheBegning: boolean;
  CustomButtonsAtTheBegning: boolean;
  CustomButtonIsGrouped: boolean;
  AllowSelectLines: boolean;
  Buttons: any[];
  VerticalView: boolean;
  ShowOnCreationInside: boolean;
  TitleFormat: string;
  WithMap: boolean;
  DisableSorting: boolean;
  TitleFormatHandlebars: string;
  AllowScan: boolean;
  LineTemplate: string;
  RenderAsTemplateByDefault: boolean;
  AllowAddTextRow: boolean;
  CollapseInOnMobile: boolean;
  IsCustomData: boolean;
  CustomDataSource: string;
  AllowSpecialLines: boolean;
  AllowLineSorting: boolean;
  QuantityFieldPropertyName: string;
  CustomActionColumnWidth: number;
}

export enum FieldDataType {
  Unkown = 0,
  String = 1,
  Number = 2,
  Select = 3,
  Link = 4,
  Date = 5,
  Time = 6,
  Text = 7,
  Price = 8,
  Percent = 9,
  Attachment = 10,
  Hidden = 11,
  Label = 12,
  Address = 13,
  PriceLocalCurrency = 14,
  PriceSystemCurrency = 15,
  PriceLines = 16,
  PriceFromDocument = 17,
  Checkbox = 18,
  MultipleDate = 19,
  HTMLEditor = 20,
  CCValidity = 21,
  Property = 22,
  Amount = 23,
  AmountFromDocument = 24,
  ItemImage = 25,
  Quantity = 26,
  Title = 27,
  Signature = 28,
  Icon = 29,
  Button = 30,
  Map = 31,
  Paragraph = 32,
  Integer = 33,
  TimeAmount = 34,
  Rate = 35,
}

export enum FieldPCAlignment {
  None = 0,
  Left = 1,
  Center = 4,
  Right = 2,
  Extended = 3,
}

export enum PortalStatusValues {
  None = 0,
  Hide = 1,
  ReadOnly = 2,
  NotEditable = 3,
  NotEditableDisabled = 4,
  EditableDisabled = 5,
  HideDisabled = 6,
}

export class Field {
  SectionId: number;
  PropertyName: string;
  FieldName: string;
  TableName: string;
  Label: string;
  DataType: FieldDataType;
  SortOrder: number;
  MaxLength?: number;
  LinkedModule?: string;
  LinkedField?: string;
  DefaultValueSQLStatementId?: number;
  EmptyValue?: string;
  ParentProperties?: string;
  Conditions?: string;
  JscriptOnChange?: string;
  JscriptOnLoad?: string;
  Disabled: boolean;
  Creatable: boolean;
  Filterable: boolean;
  Required: boolean;
  ReadOnly: boolean;
  Editable: boolean;
  InTableSortOrder: number;
  SQLStatementId?: number;
  SQLStatementParentChanged?: number;
  FilterSQLStatementId?: number;
  PCAlignment: FieldPCAlignment;
  LinkedModuleGroup?: string;
  AdditionalInformation: string;
  Options?: any;
  RangeField?: boolean;
  AdditionalInformationParsed: FieldAdditionalInformation;
  PortalStatus?: PortalStatusValues;
  VisibleInDialogOnly?: boolean;
  FieldDescription: string;
  Id: number;
  //RecordDescription: string;
  //Areas: number[];
  Value: any;
  MinValue?: any;

  static getValuesToPassBasedOnConditions(
    f: Field,
    recordModel: RecordModel,
    lineId: number,
    linkedFieldSectionTagName: string,
  ): { Key: string; Value: string }[] {
    if (
      f.Conditions === '' ||
      f.Conditions === undefined ||
      f.Conditions === null
    ) {
      return [];
    } else {
      const parameters = f.Conditions.match(/{\#(.+?)}/g);
      if (parameters !== null) {
        const result = [];
        for (let parameter of parameters) {
          parameter = parameter.replace('{#', '').replace('}', '');

          const xmlTagName = parameter.split('.')[0];
          const propertyName = parameter.split('.')[1];
          let line: RecordLine = null;
          if (xmlTagName === linkedFieldSectionTagName) {
            line = recordModel.Categories.find((c) => c.Id === xmlTagName)
              .Lines[lineId];
          } else {
            line = recordModel.Categories.find((c) => c.Id === xmlTagName)
              .Lines[0];
          }

          const prop = line.Properties.find((p) => p.Name === propertyName);
          if (prop.DataType === FieldDataType.Date) {
            result.push({
              Key: `${xmlTagName}.${propertyName}`,
              /*Value: moment(prop.ValueAsObject).format(
                g.companyConfiguration.MomentDateFormat
              )*/
              Value: prop.ValueAsObject,
            });
          } else {
            const value =
              line.Properties.find((p) => p.Name === propertyName)
                .ValueAsObject == null
                ? ''
                : line.Properties.find((p) => p.Name === propertyName)
                    .ValueAsObject;
            result.push({
              Key: `${xmlTagName}.${propertyName}`,
              Value: value,
            });
          }
        }

        return result;
      }
    }
  }
}

export interface FieldAdditionalInformation {
  Width: number;
  Properties: any[];
  IsSelect2: boolean;
  Visible: boolean;
  LinkedFieldInQuery: string;
  LinkedFieldInMinValue: string;
  LinkedFieldInMaxValue: string;
  LinkedFieldMinValueToolTip: string;
  LinkedFieldMaxValueToolTip: string;
  LinkedFieldInReadonly: string;
  LinkedFieldInRequired: string;
  LinkedFieldInVisible: string;

  SortOrderInDialog?: any;
  SelectionCriteriaNumber?: any;
  SelectionCriteriaLinkedField?: string;
  GroupInDialog?: any;
  GroupInDialogTitle?: string;
  MultipleDate?: any;
  VisibleInDialog: boolean;
  DataLabel?: any;
  FilterDefaultValue: string;
  LabelClass?: any;
  ExpressionInFilterList: string;
  ExpressionInFilterListHana?: any;
  EditableInList: boolean;
  SecondaryId: boolean;
  IsMultiple: boolean;
  SelectOptionsAsCards: boolean;
  LabelOnRight: boolean;
  SendToMobileApp: boolean;
  NameInAPI?: any;
  UseConditionsInAutoComplete: boolean;
  Icon?: any;
  LabelVisible: boolean;
  ShowEye: boolean;
  BigAddButton: boolean;
  SearchButton: string;
  AddButtonText?: any;
  FieldClassName?: any;
  AddButtonIcon?: any;
  ShowOutsideLines: boolean;
  ShowOutsideLines_CurrentInTable: boolean;
  ShowInAutoCompleteList: boolean;
  IsLabelATextArea: boolean;
  TextAreaRows: number;
  DisableCurrency: boolean;
  FunctionToExecute: string;
  CustomLabel: string;
  CreateNewInside: boolean;
  WidthInList: number;
  ValueYes: string;
  ValueNo: string;
  IsDatePickerMonthMode: boolean;
  MonthModeBeginOfMonth: boolean;
  MonthModeEndOfMonth: boolean;
  VisibleInTableList: boolean;
  OptionsToBeTranslated: boolean;
  VisibleInDialogOnly: boolean;
  IsImage: boolean;
  AllowUploadFile: boolean;
  AllowSignature: boolean;
  AllowUsingCamera: boolean;
  DataSourcePath: string;
  IsPassword: boolean;
  IsLink: boolean;
  FilterableInDraft: boolean;

  ItemCodePropertyPropertyName: string;
  ItemDescriptionPropertyName: string;
  ITMSerialNumberPropertyName: string;
  UnitOfMeasurmentPropertyName: string;
  OpenQuantityPropertyName: string;
  UomEntryPropertyName: string;
  WarehouseCodePropertyName: string;
  EnableSearch: boolean;
  UniqueDefaultValue: boolean;
  ValueFromParentIfChild: boolean;
  DisabledDatesSQLStatementId: number;
  AllowedDatesRangeSQLStatementId: number;

  WarningMessageEnabled: boolean;
  WarningMessageText: string;
  WarningRegex: string;
  WarningRegexCondition: WarningRegexCondition;

  UniqueValueValidationQuery: number;
  WarningMsgOnValueChangeQuery: number;

  DisplayTotalsInList: boolean;

  FixedInTableType: FixedType;

  AffectFormMode: boolean;
}

export enum WarningRegexCondition {
  Match = 0,
  NoMatch = 1,
}

export enum FixedType {
  None = 0,
  Left = 1,
  Right = 2,
}
export interface ModuleButton {
  SectionId: number;
  IsLoading: boolean;
  OptionsSQLStatementId: number;
  Options: any[];
  AdditionalInformationParsed: ModuleButtonAdditionalInformation;
}

export interface ModuleButtonAdditionalInformation {
  DisplayConditions: string;
  Label: string;
  CustomActionCode: string;
  OnLineLevel: boolean;
  ExecuteOnClientSide: boolean;
  AllowInEditMode: boolean;
  AllowInAddMode: boolean;
  AllowInViewMode: boolean;
  RenderBeforeSectionContent: boolean;
  ShowConfirmation: boolean;
  ConfirmationMessage: string;
  SubmitBeforeExecute: boolean;
  WorkingOnSelectedLines: boolean;
  IsPrimary: boolean;
  ButtonIcon: string;
  ButtonClass: string;
  CustomFieldSectionId: number;
}

export interface Values {
  [key: string]: string | number | Date;
}
